import { Component, OnInit, Input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() title = '';

  public i18n: any;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.translate.get('LOADING_SPINNER').subscribe(
      (translations) => this.i18n = translations
    );
  }

}
